import { skipToken } from '@reduxjs/toolkit/query';
import { CommanderAPI } from '../CommanderAPI';
import { ITypeRequest } from '../../../../theme/ui/Dashboard/Dashboard.model';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../store/Store.constants';
import useAggregatedGetAirConnectStatusBySubworkspaces from './useAggregatedGetAirConnectStatusBySubworkspaces';

interface IUseAirConnectStatusProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}

/**
 * AirConnect status by request scope (user/group/workspace/workspaces).
 * For workspaces, data is aggregated across child workspaces.
 */
function useAirConnectStatus(props: IUseAirConnectStatusProps) {
  const { typeRequest, groupId, workspaceId } = props;
  const workspacesDevicesAirConnectStatusResponse =
    useAggregatedGetAirConnectStatusBySubworkspaces(
      typeRequest === 'workspaces'
    );

  const userDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByUserQuery(undefined, {
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      skip: typeRequest !== 'user',
    });

  const groupDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByGroupQuery(groupId ?? skipToken, {
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      skip: typeRequest !== 'group',
    });

  const workspaceDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByWorkspaceQuery(
      workspaceId ?? skipToken,
      {
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
        skip: typeRequest !== 'workspace',
      }
    );

  switch (typeRequest) {
    case 'user':
      return userDevicesAirConnectStatusResponse;
    case 'group':
      return groupDevicesAirConnectStatusResponse;
    case 'workspace':
      return workspaceDevicesAirConnectStatusResponse;
    case 'workspaces':
      return workspacesDevicesAirConnectStatusResponse;
    default:
      return userDevicesAirConnectStatusResponse;
  }
}

export default useAirConnectStatus;
